import { render, staticRenderFns } from "./Ic_header.vue?vue&type=template&id=4de52a66&scoped=true&"
import script from "./Ic_header.vue?vue&type=script&lang=js&"
export * from "./Ic_header.vue?vue&type=script&lang=js&"
import style0 from "./Ic_header.vue?vue&type=style&index=0&id=4de52a66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de52a66",
  null
  
)

export default component.exports